import { gql } from "@apollo/client"
import {
  CompanyPayrollArgs,
  DownloadLink,
  PayrollStateTypeEnum,
  QueryCompanyArgs,
} from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

interface CompanyPayrollDownloadsReturnType {
  company: {
    id: string
    payroll?: {
      id: string
      state: PayrollStateTypeEnum
      preFundingInvoice?: {
        supportingFile?: Pick<DownloadLink, "url">
      }
      settlementInvoice?: {
        supportingFile?: Pick<DownloadLink, "url">
      }
    }
  }
}

const GET_COMPANY_PAYROLL_DOWNLOADS = gql`
  query CompanyPayrollDownloads($companyId: ID!, $month: Int!, $year: Int!) {
    company(companyId: $companyId) {
      id
      payroll(month: $month, year: $year) {
        id
        state
        preFundingInvoice {
          supportingFile {
            url
          }
        }
        settlementInvoice {
          supportingFile {
            url
          }
        }
        records {
          __typename
        }
      }
    }
  }
`

type UseCompanyPayrollDownloadsArgs = QueryCompanyArgs & CompanyPayrollArgs

export function useCompanyPayrollDownloads({
  companyId,
  year,
  month,
}: UseCompanyPayrollDownloadsArgs) {
  return useQuery<CompanyPayrollDownloadsReturnType>(GET_COMPANY_PAYROLL_DOWNLOADS, {
    variables: {
      companyId,
      year,
      month,
    },
  })
}
